import * as React from 'react';
import { Coords } from 'google-map-react';
import { CSNBoundingBox, CSNGeographicPointFilter, CSNSearchVenueData } from '@weddingspot/ws-api-client';

export interface ResolvedSearchLocation {
    query: string;
    boundingBox: CSNBoundingBox;
    geoFilter: CSNGeographicPointFilter;
}

export type SearchLocation = Partial<ResolvedSearchLocation>;

interface SearchContext {
    query: string | undefined;
    setSearchLocation: (location: ResolvedSearchLocation) => void;
    queryLocation: Coords | undefined;
    searchResults: undefined | CSNSearchVenueData[];
    setSearchResults: (results: CSNSearchVenueData[]) => void;
}

export const SearchContext = React.createContext<SearchContext>({
    query: undefined,
    setSearchLocation: () => {},
    queryLocation: undefined,
    searchResults: undefined,
    setSearchResults: (results: CSNSearchVenueData[]) => {},
});
